<template>
  <div class="services container" style="padding: 5em 2em">
    <h2 class="page-title">Services</h2>
    <div class="d-none d-lg-block">
      <b-nav tabs align="center">
        <b-nav-item
          :active="!isBusinessActive"
          @click="
            show = true;
            isBusinessActive = false;
          "
          ><h5>Coaching Sessions</h5>
          </b-nav-item>
        <b-nav-item
          :active="isBusinessActive"
          @click="
            show = false;
            isBusinessActive = true;
          "
        >
          <h5>Product</h5>
        </b-nav-item>
        
      </b-nav>
    </div>

    <div class="d-block d-lg-none">
      <b-nav tabs align="center">
         <b-nav-item
          :active="!isBusinessActive"
          @click="
            show = true;
            isBusinessActive = false;
          "
          ><h5 style="font-size: 3vw">Coaching Sessions</h5></b-nav-item
        >
        <b-nav-item
          :active="isBusinessActive"
          @click="
            show = false;
            isBusinessActive = true;
          "
          ><h5 style="font-size: 3vw">
            Product
          </h5></b-nav-item
        >
       
      </b-nav>
    </div>
    <div class="row" align="center">
      <!--<div class="col">
        <Card
          v-show="show"
          title="The Shining Program"
          body="Three months of custom-designed program to maximize your potential in any area of your life that you wish/choose to focus on"
          :price="1999"
          id="The Shining Program"
          time="10 Hour"
          popupData="If you’re having a difficult time managing work-life balance; your wheelbarrow is full of work, and you do not have clarity of prioritization. You find yourself afraid to ask for help; you would rather maintain the status quo than show signs of vulnerability. I can help !."
          description="Three months of custom-designed program to maximize your potential in any area of your life that you wish/choose to focus on"
        ></Card>
      </div>-->

      <div class="col">
        <Card
          v-show="show"
          title="One-on-one Coaching Session"
          body="Identify goals. Maximize performance. Personal and professional development."
          :price="100"
          id="One-on-one Coaching Session"
          time="1 Hour"
          description="Identify goals. Maximize performance. Personal and professional development."
          popupData="
                  Sometimes all that you need is just some clarity, professional advise, consultation, or even just someone to talk to. Sometimes problems can be solved in only one session; sometimes we are just around the corner from where we want to be and need some fine tuning. 
                  <br /> Whether you are considering a career change, conflicted on which college or courses to choose, thinking about moving, or need to share anything that’s on your mind, I am here for you. I can help. 
                  <br /> Sometimes all we need is a little guidance and a push in the right direction.
                  Just click right here and choose the time that works the best for you. 
                  I’ll see you on the other side :)"
        ></Card>
      </div>
      <!--<div class="col">
        <Card
          v-show="show"
          title="The Shining Program"
          body="Six life-changing coaching sessions. Uncover your purpose to bring fulfillment and abundance into your life."
          :price="900"
          id="Kickstarter Shining Kit"
          time="1 Hour"
          description="Six life-changing coaching sessions. Uncover your purpose to bring fulfillment and abundance into your life."
          popupData="You're looking to become a better Leader, better parent, better spouse, a better person for you. You have had it with the routine lifestyle and of living a life filled with self-doubt, worry, and anxiety. You’re demotivated and not seeing hope in what you do or the way you live. You’re not getting results and prisoner inside your own head. You feel this is not the life you have ordered. I can help !."
        ></Card>
      </div> -->
    </div>

    <div align="center">
      <div class="row" align="center">
        <div class="col">
          <Card
            v-show="!show"
            title="Productivity Accelerator"
            body="4 weeks. Control your time. Organize your thoughts. Immediate results."
            :price="300"
            id="Productivity Accelerator"
            time="1 Hour"
            description="4 weeks. Control your time. Organize your thoughts. Immediate results."
          ></Card>
        </div>
        <!-- <div class="col">
          <Card
            v-show="!show"
            title="One-on-one Career Coaching"
            body="Career direction, interview preparation, and resumé review. Rebrand yourself."
            :price="149"
            id="One-on-one Career Coaching"
            time="1 Hour"
            description="Career direction, interview preparation, and resumé review. Rebrand yourself."
            popupData="If you are thinking of changing your career, or you’re working in a role that you did not apply for, or you’re stuck in the same routine job and feel it is time to rub the Magic Lamp to get the career of your dreams. I can help :)."
          ></Card>
        </div> -->
      </div>
    </div>
    
    <ReviewsCarousel />
  </div>
</template>

<!-- <script src="https://js.stripe.com/v3/"></script>  -->

<script>
import Card from "../components/Card";
import ReviewsCarousel from "../components/LinkedinReviewsCarousel";

export default {
  name: "Services",
  data() {
    return {
      show: true,
      isBusinessActive: false,
    };
  },
  components: {
    Card,
    ReviewsCarousel,
  },
  methods: {},
  created() {},
};
</script>

<style scoped lang="scss">
.nav {
  flex-wrap: nowrap !important;
}

.nav-tabs .nav-link {
  color: #ff6e92;
  border: 1px solid #ff6e92;
  border-bottom: none;

  h5 {
    margin-bottom: 0;
  }

  &:hover {
    border: 1px solid #ff6e92;
    border-bottom: none;
  }
}

.nav-tabs .nav-item.show .nav-link,
.nav-tabs .nav-link.active {
  color: #fff;
  background-color: #ff6e92;
  border-color: #ff6e92;
}
</style>
